const rootStyles = `

:host {
    --header-bg: #ffffff;
    --header-text: #000000b2;
    --nav-hover: #1679e8;
    --hover-text: #ffffff;
    --nav-bg: linear-gradient(
        0deg,
        rgba(61, 148, 246, 0.05),
        rgba(61, 148, 246, 0.05)
      ),
      linear-gradient(0deg, #ffffff, #ffffff);
    --side-inner-bg: rgba(0, 0, 0, 0.025);
    --input-bg: #ffffff;
    --input-placeholder-color: #808080;
    --input-border: 1px solid #cccccc;
    --text-color: #000000b2;
    --heading-bg: rgba(0, 0, 0, 0.025);
    --heading-shadow: 0px 2px 0px rgba(0, 0, 0, 0.1);
    --border-radius: 5px;
    --nav-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
    --nav-border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    --quick-link-heading: #00000066;
    --group-heading-bg: rgba(0, 0, 0, 0.025);
    --header-border-bottom: 0.2px solid #bdbdbd;
    --group-heading-border-bottom: 0.2px solid #bdbdbd;
    --user-bg: rgba(0, 0, 0, 0.05);
    --action-drop-bg: #f9f9f9;
    --divider-bg: rgba(0, 0, 0, 0.1);
    --clock-out-bg: #e0e0e0;
    --clock-text: #000000;
    --clock-svg: rgba(0, 0, 0, 0.7);
    --btn-main-bg: #3d94f6;
    --btn-main-text: rgba(255, 255, 255, 0.8);
    --toggle-active: rgba(0, 0, 0, 0.05);
    --sub-menu-bg: rgba(0, 0, 0, 0.05);
    --sm-bg: #fff;
    --global-search-container-bg: linear-gradient(
      0deg,
      rgba(61, 148, 246, 0.05),
      rgba(61, 148, 246, 0.05)
    );
    --global-search-color: #000000b2;
    --esc-border-color: rgba(0, 0, 0, 0.4);
    --icon-color: #4b4b4b;
    --notify-bg: rgba(0, 0, 0, 0.025);
    --enter-bg: #4b4b4b;
    --s-quick-link-bg: #384555;
    --s-quick-link-color: #ffff;
    --s-result-border-color: #384555;
    --s-result-hover-bg: #384555;
    --s-section-header-color: #000000b2;
    --s-breadcrumbs-color: #000000b2;
    --s-section-header-color-hover: rgba(255, 255, 255, 0.6);
    --s-quick-link-hover: rgba(0, 0, 0, 0.4);
    --key-bg: linear-gradient(
      0deg,
      rgba(61, 148, 246, 0.05),
      rgba(61, 148, 246, 0.05)
    );
    font-family: ErplyLadna, sans-serif;
  }
  
  [data-theme="dark"] {
    --key-bg: rgba(0, 0, 0, 0.4);
    --s-quick-link-bg: rgba(255, 255, 255, 0.1);
    --s-quick-link-hover: rgba(255, 255, 255, 0.3);
    --s-result-border-color: rgba(255, 255, 255, 0.1);
    --s-result-hover-bg: rgba(0, 0, 0, 0.4);
    --s-breadcrumbs-color: rgba(255, 255, 255, 0.6);
    --s-quick-link-color: #ffff;
    --s-section-header-color: rgba(255, 255, 255, 0.6);
    --s-section-header-color-hover: rgba(255, 255, 255, 0.6);
    --icon-color: #bec2c8;
    --header-bg: #1e2833;
    --sm-bg: #223042;
    --header-text: rgba(255, 255, 255, 0.8);
    --nav-hover: #fff;
    --nav-bg: #223042;
    --side-inner-bg: rgba(255, 255, 255, 0.025);
    --input-bg: rgba(255, 255, 255, 0.05);
    --input-placeholder-color: rgba(255, 255, 255, 0.4);
    --input-border: 1px solid rgba(0, 0, 0, 0.2);
    --text-color: #ffffff;
    --heading-bg: rgba(255, 255, 255, 0.8);
    --heading-shadow: none;
    --nav-shadow: none;
    --nav-border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    --quick-link-heading: #ffffffcc;
    --group-heading-bg: #223042;
    --group-heading-border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    --header-border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    --user-bg: #ffffff0d;
    --hover-text: #000000b2;
    --action-drop-bg: #283547;
    --divider-bg: rgba(255, 255, 255, 0.1);
    --clock-out-bg: rgba(255, 255, 255, 0.2);
    --clock-text: #ffffff;
    --clock-svg: rgba(255, 255, 255, 0.7);
    --btn-main-bg: #ffff;
    --btn-main-text: rgba(0, 0, 0, 0.8);
    --toggle-active: rgba(255, 255, 255, 0.1);
    --sub-menu-bg: #384555;
    --global-search-container-bg: #ffff;
    --global-search-color: #000000b2;
    --esc-border-color: rgba(0, 0, 0, 0.4);
    --notify-bg: rgba(255, 255, 255, 0.05);
    --enter-bg: #a1a4a9;
  }
  
  * {
    box-sizing: border-box;
    font-family: ErplyLadna !important;
  }
  
  ul {
    list-style-type: none;
    /* margin: 0; */
    padding: 0;
  }
  
  a {
    text-decoration: none;
    color: inherit;
    cursor: pointer;
  }
  
  .actions {
    display: flex;
    align-items: center;
    /* position: relative; */
  }
  
  .actions svg {
    margin-top: 17px;
    margin-bottom: 15px;
    fill: var(--header-text);
    cursor: pointer;
  }
  
  .actions svg:hover {
    fill: var(--nav-hover);
  }
  
  .user {
    height: 40px;
    width: 40px;
    border-radius: 100px;
    padding: 10px;
    background: var(--user-bg);
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .input {
    width: 100%;
    padding: 12px 30px 12px 12px;
    background: var(--input-bg);
    border: var(--input-border);
    border-radius: var(--border-radius);
    color: var(--text-color);
  }
  
  .input:focus {
    border-color: var(--nav-hover);
    outline: 0 none;
  }
  
  .input-form {
    position: relative;
  }
  
  .input-form svg {
    position: absolute;
    right: 12px;
    top: 12px;
    fill: var(--input-placeholder-color);
  }
  
  input::placeholder {
    color: var(--input-placeholder-color);
  }
  
  .drop-text {
    font-size: 14px;
    font-style: normal;
    font-weight: 96;
    line-height: 24px;
    letter-spacing: 0.005em;
    text-align: left;
    margin-left: 10px;
  }
  
  .search-container {
    display: flex;
    align-items: center;
    background: var(--global-search-container-bg);
    padding: 0px 10px 0px 10px;
    width: 600px;
    border-bottom: none;
    height: 51.25px;
    color: var(--global-search-color);
  }
  
  .search-container svg {
    fill: var(--global-search-color);
    opacity: 0.5;
  }
  
  .search-container input {
    width: 100%;
    padding: 12px 30px 12px 12px;
    background: var(--global-search-container-bg);
    border: none;
    font-weight: 96;
    font-size: 16px;
    line-height: 20px;
    color: var(--global-search-color);
  }
  
  .search-container input:focus {
    outline: 0 none;
    background: transparent;
  }
  
  .esc {
    width: 38px;
    height: 24px;
    border: 1px solid var(--esc-border-color) !important;
    box-sizing: border-box;
    border-radius: 3px;
    background-color: #fff;
    color: rgba(0, 0, 0, 0.6);
    cursor: pointer;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 20px;
  }
  
  .search-container input::placeholder {
    color: var(--global-search-color) !important;
    opacity: 0.5;
  }
  
  .init-render svg {
    width: 16px;
    height: 17px;
  }
  
  .notify {
    background: var(--notify-bg);
    border-radius: 5px;
    width: 100%;
    padding: 25px;
  }
  
  .key {
    width: auto;
    height: 24px;
    background: var(--key-bg);
    border: 1px solid rgba(255, 255, 255, 0.4);
    box-sizing: border-box;
    border-radius: 3px;
    padding: 1px 8px 3px;
    margin: 0px 10px;
    text-align: center;
    color: var(--text-color);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .key-sm {
    width: auto;
    height: 24px;
    background: var(--key-bg);
    border: 1px solid rgba(255, 255, 255, 0.4);
    box-sizing: border-box;
    border-radius: 3px;
    padding: 1px 8px 3px;
    margin: 0px 10px;
    text-align: center;
    color: var(--text-color);
  }
  
  .key svg {
    padding-top: 2px;
    margin-right: 5px;
  
    /* fill: var(--icon-color); */
    stroke: var(--text-color);
  }
  
  .key-sm svg {
    padding-top: 2px;
    margin-right: 5px;
  
    /* fill: var(--icon-color); */
    stroke: var(--enter-bg);
  }
  
  .s-section-header {
    font-weight: bold;
    font-size: 14px;
    line-height: 24px;
    color: var(--s-section-header-color);
    margin-top: 10px;
    margin-bottom: 10px;
    display: block;
  }
  
  .s-results-menu {
    padding: 20px 15px 20px 32px;
    border-top: 0.5px solid var(--s-result-border-color);
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .s-results-menu:last-child {
    border-bottom: 0.5px solid var(--s-result-border-color);
  }
  
  .s-breadcrumbs {
    display: block;
    margin-top: 5px;
    font-size: 12px;
    color: var(--s-breadcrumbs-color);
  }
  
  .s-results-link {
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */
  
    letter-spacing: 0.005em;
  }
  
  .active-result,
  .s-results-menu:hover {
    background: var(--s-result-hover-bg);
  }
  
  .s-results-menu:hover .s-results-link {
    color: var(--s-section-header-color-hover);
  }
  
  .s-results-menu:hover .s-breadcrumbs {
    color: var(--s-section-header-color-hover);
  }
  
  .s-results-menu svg {
    stroke: var(--enter-bg);
  }
  
  .s-results-menu:hover svg {
    stroke: var(--s-section-header-color-hover);
  }
  
  .release-info {
    position: absolute;
    right: 40px;
    font-weight: 600;
    top: 5px;
  }
  

`;

export default rootStyles;
